import React from "react";
import { Shield, Award, Globe, Lock, FileCheck, Eye } from "lucide-react";

const items = [
  { icon: Award, label: "ISO 27001 Lead Auditor" },
  { icon: FileCheck, label: "EBIOS Risk Manager" },
  { icon: Shield, label: "ISO 27005 Certified" },
  { icon: Eye, label: "Blue Team / SOC" },
  { icon: Lock, label: "RGPD · NIS2 · DORA" },
  { icon: Globe, label: "ANSSI Compliance" },
];

const sectors = [
  "BANQUE / FINTECH",
  "INDUSTRIE",
  "SANTÉ",
  "TÉLÉCOMS",
  "SECTEUR PUBLIC",
  "SAAS / TECH",
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="relative border-y border-white/5 bg-[#080F0B] py-12"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start lg:items-center justify-between">
          <div className="lg:max-w-xs shrink-0">
            <div className="font-mono text-[11px] text-emerald-400 mb-2 tracking-widest">
              // ILS NOUS FONT CONFIANCE
            </div>
            <div className="text-sm text-gray-400 leading-relaxed">
              Des organisations exigeantes, dans des secteurs régulés et
              critiques, à travers la France, le Sénégal et au-delà.
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="flex flex-wrap gap-2.5 mb-5">
              {sectors.map((s, i) => (
                <span
                  key={i}
                  className="font-mono text-[10px] px-3 py-1.5 rounded-full border border-[#1A2E22] bg-[#0C1410] text-gray-400 tracking-wider"
                >
                  {s}
                </span>
              ))}
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
              {items.map((it, i) => (
                <div
                  key={i}
                  className="group flex items-center gap-2.5 px-3 py-2.5 rounded-xl border border-[#1A2E22] hover:border-emerald-500/30 transition-colors"
                >
                  <it.icon className="w-4 h-4 text-emerald-400 shrink-0" />
                  <span className="text-[11px] text-gray-300 leading-tight font-medium">
                    {it.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
